import { useState, useEffect } from 'react';
//import { tenant as tenantApi } from '../services/api';
import { PlanRequerido } from '../services/permisos';

const API_URL = 'https://bot.devit.es/api';
const headers = () => ({
  'Authorization': `Bearer ${localStorage.getItem('devit_token')}`
});

const CANAL_ICON = {
  'web':       '🌐',
  'messenger': '💬',
  'instagram': '📸',
  'test':      '🧪',
  'default':   '💬',
};

function getCanal(session_id) {
  if (session_id.startsWith('web_')) return 'web';
  if (session_id.startsWith('messenger_')) return 'messenger';
  if (session_id.startsWith('instagram_')) return 'instagram';
  if (session_id.startsWith('test')) return 'test';
  return 'whatsapp';
}

function getIcon(session_id) {
  const canal = getCanal(session_id);
  return canal === 'whatsapp' ? '📱' : CANAL_ICON[canal] || '💬';
}

export default function Conversaciones({ permisos, onUpgrade }) {
  const [sesiones, setSesiones]     = useState([]);
  const [seleccionada, setSeleccionada] = useState(null);
  const [mensajes, setMensajes]     = useState([]);
  const [loading, setLoading]       = useState(true);
  const [filtro, setFiltro]         = useState('todos');

  useEffect(() => {
    fetch(`${API_URL}/tenants/conversaciones`, { headers: headers() })
      .then(r => r.json())
      .then(data => { setSesiones(Array.isArray(data) ? data : []); setLoading(false); });
  }, []);

  if (!permisos?.conversaciones) return <PlanRequerido onUpgrade={onUpgrade} />;

  const abrirConversacion = (session_id) => {
    setSeleccionada(session_id);
    fetch(`${API_URL}/tenants/conversaciones/${session_id}`, { headers: headers() })
      .then(r => r.json()).then(setMensajes);
  };

  const formatFecha = (str) => {
    const d = new Date(str);
    return d.toLocaleDateString('es-ES', { day:'2-digit', month:'short' }) +
    ' ' + d.toLocaleTimeString('es-ES', { hour:'2-digit', minute:'2-digit' });
  };

  const canales = ['todos', 'whatsapp', 'web', 'messenger', 'instagram'];
  const sesionesFiltradas = filtro === 'todos'
    ? sesiones
    : sesiones.filter(s => getCanal(s.session_id) === filtro);

  return (
    <div>
      <div className="topbar">
        <div>
          <div className="page-title">Conversaciones</div>
          <div className="page-sub">Historial de chats de tu agente</div>
        </div>
      </div>

      <div className="content" style={{padding:'0'}}>
        <div style={{display:'grid', gridTemplateColumns:'300px 1fr', height:'calc(100vh - 60px)'}}>

          {/* Lista */}
          <div style={{borderRight:'1px solid var(--border)', overflowY:'auto', display:'flex', flexDirection:'column'}}>
            {/* Filtros de canal */}
            <div style={{padding:'10px 12px', borderBottom:'1px solid var(--border)', display:'flex', gap:'4px', flexWrap:'wrap'}}>
              {canales.map(c => (
                <button key={c} onClick={() => setFiltro(c)}
                  style={{
                    fontSize:'10px', padding:'3px 8px', borderRadius:'4px', cursor:'pointer',
                    border: filtro === c ? '1px solid var(--green)' : '1px solid var(--border)',
                    background: filtro === c ? 'rgba(0,229,160,0.1)' : 'transparent',
                    color: filtro === c ? 'var(--green)' : 'var(--text3)',
                    fontFamily: 'var(--font-mono)'
                  }}>
                  {c}
                </button>
              ))}
            </div>

            <div style={{flex:1, overflowY:'auto'}}>
              {loading && <div style={{padding:'20px', color:'var(--text3)', fontSize:'12px'}}>Cargando...</div>}
              {!loading && sesionesFiltradas.length === 0 && (
                <div style={{padding:'20px', color:'var(--text3)', fontSize:'12px'}}>
                  Sin conversaciones en este canal.
                </div>
              )}
              {sesionesFiltradas.map(s => (
                <div key={s.session_id} onClick={() => abrirConversacion(s.session_id)}
                  style={{
                    padding:'12px 14px', borderBottom:'1px solid var(--border)', cursor:'pointer',
                    background: seleccionada === s.session_id ? 'var(--bg3)' : 'transparent',
                    borderLeft: seleccionada === s.session_id ? '2px solid var(--green)' : '2px solid transparent',
                  }}
                >
                  <div style={{display:'flex', justifyContent:'space-between', marginBottom:'4px'}}>
                    <span style={{fontSize:'12px', color:'var(--text)', fontWeight:500}}>
                      {getIcon(s.session_id)} {s.session_id.length > 18 ? s.session_id.slice(0,18)+'...' : s.session_id}
                    </span>
                    <span style={{fontSize:'10px', color:'var(--text3)', fontFamily:'var(--font-mono)'}}>
                      {formatFecha(s.ultimo)}
                    </span>
                  </div>
                  <div style={{fontSize:'11px', color:'var(--text3)'}}>
                    {s.mensajes} mensajes · {getCanal(s.session_id)}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Mensajes */}
          <div style={{display:'flex', flexDirection:'column', overflowY:'auto', background:'var(--bg)'}}>
            {!seleccionada && (
              <div style={{flex:1, display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text3)', fontSize:'13px'}}>
                Selecciona una conversación
              </div>
            )}
            {seleccionada && (
              <>
                <div style={{padding:'10px 16px', borderBottom:'1px solid var(--border)', background:'var(--bg2)',
                  fontSize:'12px', color:'var(--text3)', fontFamily:'var(--font-mono)',
                  display:'flex', alignItems:'center', gap:'8px'}}>
                  <span>{getIcon(seleccionada)}</span>
                  <span>{seleccionada}</span>
                  <span className={`badge badge-${getCanal(seleccionada) === 'whatsapp' ? 'green' : getCanal(seleccionada) === 'web' ? 'cyan' : getCanal(seleccionada) === 'instagram' ? 'amber' : 'red'}`} style={{fontSize:'9px'}}>
                    {getCanal(seleccionada)}
                  </span>
                </div>
                <div style={{flex:1, overflowY:'auto', padding:'16px', display:'flex', flexDirection:'column', gap:'10px'}}>
                  {mensajes.filter(m => m.role !== 'sistema').map((m, i) => (
                    <div key={i} style={{display:'flex', justifyContent: m.role === 'usuario' ? 'flex-end' : 'flex-start'}}>
                      <div style={{
                        maxWidth:'70%', padding:'10px 14px', borderRadius:'10px',
                        fontSize:'13px', lineHeight:'1.5', whiteSpace:'pre-wrap',
                        background: m.role === 'usuario' ? 'rgba(0,229,160,0.1)' : 'var(--bg3)',
                        color: m.role === 'usuario' ? 'var(--green)' : 'var(--text)',
                        border: `1px solid ${m.role === 'usuario' ? 'rgba(0,229,160,0.2)' : 'var(--border)'}`,
                      }}>
                        {m.mensaje}
                        <div style={{fontSize:'10px', color:'var(--text3)', marginTop:'4px', fontFamily:'var(--font-mono)'}}>
                          {m.role === 'usuario' ? '👤' : '🤖'} {formatFecha(m.timestamp)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
